<div [ngClass]="{'alert-border': danger}" class="card">
    <div class="d-flex align-items-center justify-content-between" (click)="toggleContent()">
        <h6 class="well-title mb-0">{{title}} <span *ngFor="let b of badge" class="ml-1 badge badge-success">{{b}} <span
                    class="pl-3" (click)="onRemoveSelection($event, b)">X</span></span></h6>
        <span class="material-icons toggle-btn">{{visible ? 'expand_less': 'expand_more'}}</span>
    </div>
    <ng-content *ngIf="visible && !loading"></ng-content>
    <div *ngIf="visible && loading" class="mb-4 spinner spinner-border spinner-border-lg text-secondary" role="status">
        <!-- <span class="sr-only">Loading...</span> -->
    </div>
</div>